import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalHelper } from '../Common/global.service';

@Injectable({
  providedIn: 'root'
})
export class AdministrationService {

  constructor(private globalHelper: GlobalHelper, private httpclient: HttpClient) { }

  //Academic------------------------------------------------------------------

  GetAllAcademic(strdata): Observable<any> {
    var param = 'objActivity=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Administration/GetAllAcademic?' + encodeURI(param), { headers: reqHeader });
  }
  SaveAcademic(strdata, File): Observable<any> {
    let formData = new FormData();
    formData.append("strdata", strdata);
    formData.append("File", File);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/SaveAcademic', formData);
  }
 

  AcademicMarkActive(AcademicID,IsActive): Observable<any> {
    var param = 'AcademicID=' + AcademicID+'&IsActive=' + IsActive;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Administration/AcademicMarkActive?' + encodeURI(param), { headers: reqHeader });
  }

  // ACTIVITY

  SaveActivity(strdata: any): Observable<any> {
    let data = 'objActivity=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/SaveActivity?' + encodeURI(data), { headers: reqHeader });
  }
  ActivityMarkActive(strdata: any): Observable<any> {
    let data = 'objActivity=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/ActivityMarkActive?' + encodeURI(data), { headers: reqHeader });
  }
  GetAllActivity(strdata): Observable<any> {
    let data = 'objActivity=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/GetAllActivity?'+ encodeURI(data), { headers: reqHeader });
  }


  // CIRCULAR

  SaveCircular(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("objCircular", data);
    formData.append("CircularFile", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/SaveCircular', formData);
  }

  CircularMarkActive(strdata: any): Observable<any> {
    let data = 'objCircular=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/CircularMarkActive?' + encodeURI(data), { headers: reqHeader });
  }
  GetAllCircular(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/GetAllCircular', { headers: reqHeader });
  }

  // NOTICE BOARD

  SaveNoticeBoard(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("NoticeDetails", data);
    formData.append("NoticeLogoFile", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/SaveNoticeBoard', formData);
  }

  NoticeMarkActive(strdata: any): Observable<any> {
    let data = 'NoticeDetails=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/NoticeMarkActive?' + encodeURI(data), { headers: reqHeader });
  }
  GetAllNotice(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/GetAllNotice', { headers: reqHeader });
  }

  // HOLIDAY LIST


  GetAllHoliday(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/GetAllHoliday', { headers: reqHeader });
  }

  SaveHoliday(strdata: any): Observable<any> {
    let data = 'objHoliday=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/SaveHoliday?' + encodeURI(data), { headers: reqHeader });
  }
  HolidayMarkActive(strdata: any): Observable<any> {
    let data = 'objHoliday=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/HolidayMarkActive?' + encodeURI(data), { headers: reqHeader });
  }

  // PHOTO GALARY


  GetAllAlbumTitlePhoto(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/GetAllAlbumTitlePhoto', { headers: reqHeader });
  }

  SaveAlbumTitle(strdata: any): Observable<any> {
    let data = 'objTitle=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/SaveAlbumTitle?' + encodeURI(data), { headers: reqHeader });
  }

  SaveAlbumPhoto(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("PhotoDetails", data);
    formData.append("AlbumPhoto", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/SaveAlbumPhoto', formData);

  }

  DeleteAlbumPhoto(strdata: any): Observable<any> {
    let data = 'PhotoList=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/DeleteAlbumPhoto?' + encodeURI(data), { headers: reqHeader });
  }


  // VIDEO GALARY

  GetAllVideoGalary(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/GetAllVideoGalary', { headers: reqHeader });
  }

  SaveVideoGalary(strdata: any): Observable<any> {
    let data = 'strdata=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/SaveVideoGalary?' + encodeURI(data), { headers: reqHeader });
  }
  DeleteVideo(strdata: any): Observable<any> {
    let data = 'strdata=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/DeleteVideo?' + encodeURI(data), { headers: reqHeader });
  }

  // TRANSFER CERTIFICATE

  SaveTC(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("NoticeDetails", data);
    formData.append("NoticeLogoFile", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/SaveTC', formData);
  }


  GetAllTC(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/GetAllTC', { headers: reqHeader });
  }

  // ADS SLIDER

  SaveAdsSlider(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("objSlider", data);
    formData.append("Slider", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/SaveAdsSlider', formData);
  }


  GetAdsSlider(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/GetAdsSlider', { headers: reqHeader });
  }

  AdsSliderMarkActive(strdata: any): Observable<any> {
    let data = 'objSlider=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/AdsSliderMarkActive?' + encodeURI(data), { headers: reqHeader });
  }

  // FACILITY

  GetAllFacility(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/GetAllFacility', { headers: reqHeader });
  }

  SaveFacility(strdata: any): Observable<any> {
    let data = 'strdata=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/SaveFacility?' + encodeURI(data), { headers: reqHeader });
  }

  FacilityMarkActive(strdata: any): Observable<any> {
    let data = 'strdata=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/FacilityMarkActive?' + encodeURI(data), { headers: reqHeader });
  }

  GetAllFaciltyImage(strdata: any): Observable<any> {
    let data = 'strdata=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/GetAllFaciltyImage?' + encodeURI(data), { headers: reqHeader });
  }

  SaveFacilityImage(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("FacilityDetails", data);
    for (var i = 0; i < file.length; i++) {
      formData.append("FacilityImages" + i, file[i]);
    }
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/SaveFacilityImage', formData);
  }

  DeleteFacilityImage(strdata: any): Observable<any> {
    let data = 'PhotoList=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/DeleteFacilityImage?' + encodeURI(data), { headers: reqHeader });
  }

  // SCHOOL INFORMATION

  GetSchoolInformation(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/GetSchoolInformation', { headers: reqHeader });
  }

  SaveSchoolInformation(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("NoticeDetails", data);
    formData.append("NoticeLogoFile", file);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/SaveSchoolInformation', formData);
  }

  DeleteSchoolInformation(SchoolInformationID): Observable<any> {
    let formData = new FormData();
    formData.append("SchoolInformationID", SchoolInformationID);  

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/DeleteSchoolInformation', formData);
  }

  // CAREER

  GetAllCareer(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/GetAllCareer', { headers: reqHeader });
  }

  // SCHOOL NEWS

  GetAllSchoolNews(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/GetAllSchoolNews', { headers: reqHeader });
  }
  SaveSchoolNews(SchoolNewsID, SchoolNews, NewsDescription): Observable<any> {
    let formData = new FormData();
    formData.append("SchoolNewsID", SchoolNewsID);
    formData.append("SchoolNews", SchoolNews);
    formData.append("NewsDescription", NewsDescription);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/SaveSchoolNews', formData);
  }

  SchoolNewsMarkActive(strdata: any): Observable<any> {
    let data = 'strdata=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/SchoolNewsMarkActive?' + encodeURI(data), { headers: reqHeader });
  }

  GetAllSchoolNewsImage(strdata: any): Observable<any> {
    let data = 'strdata=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/GetAllSchoolNewsImage?'
      + encodeURI(data), { headers: reqHeader });
  }

  SaveSchoolNewsImage(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("NewsDetails", data);
    for (var i = 0; i < file.length; i++) {
      formData.append("NewsImages" + i, file[i]);
    }
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/SaveSchoolNewsImage', formData);
  }
  DeleteSchoolNewsImage(strdata: any): Observable<any> {
    let data = 'PhotoList=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/DeleteSchoolNewsImage?' + encodeURI(data), { headers: reqHeader });
  }



}
